module.exports = __webpack_public_path__ + "img/47.aa643ea8.jpg";